<div class="game" (click)="toggleOverlay()">

  <div class="game__badges">
    @switch (true) {
      @case (game()['hot']) {
        <img class="game__badges--item" [width]="isMobile() ? 42 : 56" [height]="isMobile() ? 15 : 20"
        src="/assets/img/badges/hot.svg" alt="hot - allstar casino">
      }
      @case (game()['jackpot']) {
        @if (jackpotValue) {
          <div class="game__badges--item jackpot-value">
            <img src="/assets/img/badges/jackpot-crown.svg" alt="jackpot-crown - allstar casino">
            {{jackpotValue}}<span>{{currency}}</span>
          </div>
        } @else {
          <img class="game__badges--item" src="/assets/img/badges/jackpot.svg" alt="jackpot - allstar casino">
        }
      }
      @case (game()['preRelease']) {
        <img class="game__badges--item" src="/assets/img/badges/exclusive.svg"
        alt="exclusive - allstar casino">
      }
      @case (game()['new']) {
        <img  class="game__badges--item" [width]="isMobile() ? 42 : 56"
        [height]="isMobile() ? 15 : 20" src="/assets/img/badges/new.svg" alt="new - allstar casino">
      }
    }
  </div>

  @if (game()['dailyDrops']) {
    <div class="game__badges--dailyDrops">
      <img  class="game__badges--item" [width]="isMobile() ? 30 : 50"
      [height]="isMobile() ? 32 : 53" src="/assets/img/badges/daily-drops.png" alt="daily-drops - allstar casino">
    </div>
  }

  <div class="game__image">
    <img defaultImage [alternative]="game()['altImgSrc']" [default]="defaultImageType.GAME" [attr.data-src]="game()?.imgSrc"
      [alt]="game().name || '' + ' - allstar casino'" class="game__image-main">
  </div>
  <div class="game__overlay" [ngClass]="{'visible': isOverflow()}" (click)="openGame(modes.real, $event)">
    <!--    <i-->
    <!--      [ngClass]="{'icon-like': !game['favorite'], 'icon-like_filled': game['favorite']}"-->
    <!--      (click)="toggleFavourite(game, $event)"-->
    <!--      class="game__overlay&#45;&#45;favourite"-->
    <!--    >-->
    <!--    </i>-->
    <img class="game__overlay--play" src="/assets/img/badges/play.png" alt="play - allstar casino">
    @if (!user.auth && !game()['nodemo']) {
      <div class="game__overlay--line-fun"></div>
      <div
        (click)="openGame(modes.demo, $event)"
        class="game__overlay--fun"
        >
        <span class="text-gradient try-fun">{{'t.try-fun' | translate}}</span>
      </div>
    }
    <a [href]="gameUrl"></a>
  </div>
</div>
<div class="game__info">
  <div class="game__info--title" [title]="game()?.name || ''">{{game()['name']}}</div>
  <div class="game__info--provider" [title]="game()['provider']?.name || ''">{{game()['provider']?.name}}</div>
</div>
